import { toast } from 'react-toastify';
import appApi from '../../../../../api/app-api';
import globalSettingsStores from '../../../../../stores/settings-stores';

export const addNewServicePaymentTypeOperations = async (
  servicePaymentType: string,
  setLoading: (isLoading: boolean) => void,
  closeDialog: () => void,
) => {
  try {
    if (servicePaymentType.length < 3 || servicePaymentType.length > 19) {
      toast.warn('על שם סוג השרות להיות בין 3 ל20 תווים בלבד');
    }
    setLoading(true);
    const createServiceType =
      await appApi.addServicePaymentType(servicePaymentType);
    globalSettingsStores.servicePaymentTypes.push(createServiceType.data.body);
    setLoading(false);
    closeDialog();
  } catch (e) {
    toast.error(`לא ניתן לבצע את הפעולה נסה שוב בעוד מספר רגעים`);
    setLoading(false);
  }
};
